export const DEMO_LISTINGS = [
  "Steinway Tower, Manhattan",
  "432 Park Avenue",
  "Four Seasons Residences, Miami",
  "Miami Beach Waterfront Estate",
  "The Wilshire, Beverly Hills",
  "West Hollywood Hills Estate",
  "181 Fremont, San Francisco",
  "Palm Beach Oceanfront Estate",
  "Paramount Miami Worldcenter",
  "520 Park Avenue",
] as const;

export type DemoListing = (typeof DEMO_LISTINGS)[number];
